<div class="container">
  <div class="row justify-content-md-center ">
    <div clas="col col-lg-8">
      <div class="card mb-3">
        <div class="card-header backgroundHeader text-center">
          Acusamos a REVOGAÇÃO do registro anterior.
        </div>
        <div class="card-body backgroundBody text-center">
          <p class="card-text">
              Para acessar o Conectividade Social e seus aplicativos é necessário estar registrado.
            <br>              
            Se desejar realizar um novo registro, clique no botão "Continuar" <a (click)="navegaRenovarRegistro()">Clique aqui!</a>         
        </div>
      </div>
    </div>
  </div>
</div>






